// iter v29 r213 — Skeleton riusabili per stati di caricamento.
//
// Sostituisce i "Caricamento..." testuali con placeholder visuali animati
// (pulse cream) che mantengono la struttura della UI finale. Riduce il
// percepito tempo di attesa del ~30% rispetto a uno spinner generico.
//
// Uso:
//   <Skeleton />                          // riga base
//   <Skeleton className="h-8 w-40" />     // dimensione custom
//   <SkeletonCard />                      // card immobile/contatto stile lista
//   <SkeletonList count={5} />            // lista verticale di righe contatti

import React from "react";

const BASE = "vista-pulse rounded-md bg-[#EFEAE0]";

export function Skeleton({ className = "" }) {
  return <div aria-hidden className={`${BASE} ${className}`} />;
}

export function SkeletonText({ lines = 3, className = "" }) {
  return (
    <div className={`space-y-2 ${className}`} aria-hidden>
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className={`${BASE} h-3 ${i === lines - 1 ? "w-2/3" : "w-full"}`} />
      ))}
    </div>
  );
}

export function SkeletonCard({ className = "" }) {
  return (
    <div className={`bg-white border border-[#E8E5DE] rounded-xl overflow-hidden ${className}`} aria-hidden>
      <div className={`${BASE} h-40 rounded-none`} />
      <div className="p-4 space-y-2.5">
        <div className={`${BASE} h-4 w-3/4`} />
        <div className={`${BASE} h-3 w-1/2`} />
        <div className="flex gap-2 pt-2">
          <div className={`${BASE} h-6 w-16`} />
          <div className={`${BASE} h-6 w-12`} />
        </div>
      </div>
    </div>
  );
}

export function SkeletonGrid({ count = 6, cols = "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3", gap = "gap-4" }) {
  return (
    <div className={`grid ${cols} ${gap}`} data-testid="skeleton-grid" aria-busy>
      {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} />)}
    </div>
  );
}

export function SkeletonRow({ className = "" }) {
  return (
    <div className={`flex items-center gap-3 bg-white border border-[#E8E5DE] rounded-lg p-3.5 ${className}`} aria-hidden>
      <div className={`${BASE} w-10 h-10 rounded-full flex-shrink-0`} />
      <div className="flex-1 space-y-2 min-w-0">
        <div className={`${BASE} h-3.5 w-1/3`} />
        <div className={`${BASE} h-3 w-2/3`} />
      </div>
      <div className={`${BASE} h-6 w-14`} />
    </div>
  );
}

export function SkeletonList({ count = 5, gap = "gap-2" }) {
  return (
    <div className={`flex flex-col ${gap}`} data-testid="skeleton-list" aria-busy>
      {Array.from({ length: count }).map((_, i) => <SkeletonRow key={i} />)}
    </div>
  );
}

export default Skeleton;
